import React, { useEffect } from "react";
import Aboutbanner from "../About/Aboutbanner";
import Callin from "../About/Callin";
import Infiry from "../About/Infiry";
import Divser from "../About/Divser";
import ServiceReview from "../Services/ServiceReview";
import { movetop } from "../../fun";
import Doctorconnew from "./Doctorconnew";
import { Helmet } from "react-helmet-async";

function Doctorpage({ doctor, banner }: { doctor: any; banner: any }) {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
    // fourBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Doctorconnew doctor={doctor} />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
    // fourBody:<Doctorboxtwo/>
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best doctors in Whitefield</title>
        <meta
          name="description"
          content="Looking for the Best doctors in Whitefield or Vijayanagar? Then you are in the right place. Contact us today."
        />
        <meta
          name="keywords"
          content="Best Doctors in Whitefield, Best Doctors in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "ELV Healthcare",
            url: "https://www.elvhealthcare.com/bestdoctor",
            logo: "https://www.elvhealthcare.com/photo/logo.png",
            description:
              "ELV Healthcare is a trusted provider of high-quality healthcare solutions, offering best doctor for all kind of problems.",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "MR ASTER, Ground Floor Vijayanagar, Whitefield, Bengaluru, Karnataka 560066",
              addressLocality: "Bangalore, Whitefield, Vijayanagar",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "India",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "12.969845",
              longitude: "77.751037",
            },
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91 9535264855",
              contactType: "customer service",
            },
            keywords: [
              "Best Doctors in Whitefield",
              "Best Doctors in Vijayanagar",
              "healthcare services in Whitefield",
              "healthcare services in Vijayanagar",
              "Multispeciality Clinic in Vijayanagar",
            ],
          })}
        </script>
      </Helmet>

      <Aboutbanner name={doctor} banner={banner} />
      {/* <ServiceList /> */}
      {/* <div style={{ backgroundColor: "#eff6ff" }} className="pb-2">
      <Infobox />
    </div> */}
      <div className="pt-2 pb-6"></div>
      <Divser elemnt={elemnt} />
      <ServiceReview />
    </>
  );
}

export default Doctorpage;
